import {useSelector} from "react-redux";
import useAuthRequest from "../../services/state/request/useAuthRequest";
import useValueChangeListener from "../../services/state/general/useValueChangeListener";
import {request} from "../../../res/rest/restRequest";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {api} from "../../../res/rest/api";
import {useState} from "react";
import useCheckoutStore from "../../cart/store/checkoutStore";

const getOrdered = (asArr) => {
    const reduce = (count, line) => {
        const pid = line.M_Product_ID?.id;
        count[pid] = (count[pid] ?? 0) + line.QtyOrdered;
        return count;
    }

    return asArr.reduce(reduce, {});
}

const formatProductList = (productIDs, ordered) => {
    return productIDs?.map(p => ({p, q: ordered[p] || 1}));
}

const getPricesCall = (products, bpID, orderID, preferences) => async (session) => {

    const req = request.process("getwebprices");
    req.param("products", products);
    req.param("c_bpartner_ID", bpID);
    req.param("c_order_id", orderID);
    req.param("preferences", preferences)
    const url = env.API_URL + req.buildRequest();

    const resp = await HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));
    return resp.data.data;
}

const useProductPrices = (productIDs, onPricesReceived) => {

    const { preferences } = useSelector(state => state.session.pricing);

    const orderID = useCheckoutStore(state => state.orderID);
    const lines = useCheckoutStore(state => state.products?.lines)
    const ordered = getOrdered(lines ?? []);

    const [ prices, setPrices ] = useState();

    const {
        loading,
        session,
        sendIt
    } = useAuthRequest();

    // TODO UOM
    // If not ordered then get quantity for both single and base uom amount
    const bpID = session.sessionData?.bPartnerID;
    const products = formatProductList(productIDs, ordered);

    const onResult = (result) => {
        setPrices(result);
        if(onPricesReceived) onPricesReceived(result);
    }

    const dispatchGetPrices = () => {
        if(session.isSignedIn && session.isCustomer
            && products?.length > 0) {
            sendIt(getPricesCall(products, bpID, orderID, preferences), onResult);
        }
    };

    useValueChangeListener(
        dispatchGetPrices,
        [productIDs, orderID, lines, preferences],
        []
    );

    return {
        loading,
        prices
    }
}

export default useProductPrices;

